// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"735":"745f2a0d","850":"85683012","919":"76901b23"}[chunkId] + ".chunk.js";
};